import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { MdOutlineDiscount } from "react-icons/md";
import useApi from "../hook/useApi";
import { toast } from "react-toastify";
import Loader from "../components/Loader/Loader";

const MasterLayout = ({ children }) => {
  const { profile, logout } = useAuth(); // get login method from context
  const { AsyncGetApiCall } = useApi();
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState(false);
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const location = useLocation(); // Hook to get the current route

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const getMaintenanceStatus = async () => {
    try {
      const result = await AsyncGetApiCall(`/admin/get-maintenance-status`);

      if (result?.errors) {
        console.error(result?.errors[0]);
      } else if (result?.success) {
        setMaintenance(result?.data);
      }
    } catch (error) {
      console.error("Something went wrong", error);
    }
  };

  const handleMaintenance = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      setLoading(true);
      const result = await AsyncGetApiCall(`/admin/update-maintenance`);

      if (result?.errors) {
        toast.error(result?.errors[0], { id: "admin-error" });
      } else if (result?.success) {
        await getMaintenanceStatus();
        toast.success(
          result?.message || "Maintenance status has been updated successfully",
          { id: "admin-success" }
        );
      }
    } catch (error) {
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMaintenanceStatus();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <section className={mobileMenu ? "overlay active" : "overlay "}>
          {/* sidebar */}
          <aside
            className={
              sidebarActive
                ? "sidebar active "
                : mobileMenu
                  ? "sidebar sidebar-open"
                  : "sidebar"
            }
          >
            <button
              onClick={mobileMenuControl}
              type="button"
              className="sidebar-close-btn"
            >
              <Icon icon="radix-icons:cross-2" />
            </button>
            <div>
              <Link to="/dashboard" className="sidebar-logo">
                <img
                  style={{
                    width: "250px",
                    height: "80px",
                  }}
                  src="/assets/images/logo.svg"
                  alt="site logo"
                  className="light-logo"
                />

                <img
                  src="/assets/images/favicon.svg"
                  alt="site logo"
                  className="logo-icon"
                />
              </Link>
            </div>
            <div className="sidebar-menu-area">
              <ul className="sidebar-menu " id="sidebar-menu">
                <li>
                  <NavLink
                    to="/dashboard"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="solar:home-smile-angle-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </NavLink>
                </li>

                {/* Users Dropdown */}

                <li>
                  <NavLink
                    to="/users-list"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="flowbite:users-group-outline"
                      className="menu-icon"
                    />
                    <span>User Management</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/whitelist-request"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="mdi:shield-check-outline"
                      className="menu-icon"
                    />

                    <span>Whitelist Request</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/hotel-booking"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="flowbite:building-solid"
                      className="menu-icon"
                    />
                    <span>Hotel Booking</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/flight-booking"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-flight-takeoff-fill menu-icon"></i>
                    <span>Flight Booking</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/esim-booking"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:sim-outline" className="menu-icon" />
                    <span>eSIM Booking</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/transactions-list"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-exchange-dollar-line menu-icon"></i>
                    <span>Transactions List</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/markups"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="material-symbols:attach-money"
                      className="menu-icon"
                    />
                    <span>Markups Control</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/country-tax"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:percent-outline" className="menu-icon" />
                    <span>Country Tax</span>
                  </NavLink>
                </li>

                <li className="sidebar-menu-group-title">Application</li>

                <li>
                  <NavLink
                    to="/review-and-rating"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="solar:star-linear" className="menu-icon" />
                    <span>Review & Rating</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/customer-support"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    {/* <i className="ti ti-headset text-[20px] mr-1"></i> */}
                    <Icon icon="tabler:headphones" className="menu-icon" />
                    {/* <Icon icon="solar:headset" className="menu-icon" /> */}
                    <span>Customer Support</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/ai-chatbot-support"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="hugeicons:ai-chat-02"
                      className="menu-icon"
                    />
                    <span>AI Chatbot Support</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/promotional-campaigns"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <img
                      src="/assets/images/promotion.png"
                      alt="Promotion Icon"
                      className="menu-icon"
                      style={{ width: "23px", height: "23px" }}
                    />
                    <span>Promotional</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/launch-deals"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="tabler:rocket" className="menu-icon" />
                    <span>Launch Deals</span>
                  </NavLink>
                </li>

                <li className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="material-symbols:description-outline"
                      className="menu-icon"
                    />
                    <span>Content</span>
                  </Link>
                  <ul className={`sidebar-submenu`}
                    style={{
                      overflow: "auto",
                      scrollbarWidth: "none", // Firefox: Hides scrollbar
                      msOverflowStyle: "none", // IE/Edge: Hides scrollbar
                      maxHeight: "50%"
                    }}
                  >
                    <li>
                      <NavLink
                        to="/terms-condition"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon="octicon:info-24" className="menu-icon" />
                        <span>Terms & Conditions</span>
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/privacy-policy"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-rocket-line menu-icon"></i>
                        <span>Privacy Policy</span>
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/about-us"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-hammer-line menu-icon"></i>
                        <span>About Us</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/faq"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="mage:message-question-mark-round"
                          className="menu-icon"
                        />
                        <span>FAQs</span>
                      </NavLink>
                    </li>


                  </ul>
                </li>

                <li>
                  <NavLink
                    to="/coupon-code"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <MdOutlineDiscount className="menu-icon" />
                    <span>Coupon</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/notifications"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:bell-outline" className="menu-icon" />
                    <span>Notifications</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/gift-cards-tx"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:gift-outline" className="menu-icon" />
                    <span>Gift Card</span>
                  </NavLink>
                </li>

                <li className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="mdi:trophy-outline"
                      className="menu-icon"
                    />
                    <span>Rewards</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/rewards-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon="octicon:history-24" className="menu-icon" />
                        <span>Transactions</span>
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/rewards-manage"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon="octicon:settings-24" className="menu-icon" />
                        <span>Configuration</span>
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/rewards-policy"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon="octicon:info-24" className="menu-icon" />
                        <span>Terms & Conditions</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </aside>

          <main
            className={
              sidebarActive ? "dashboard-main active" : "dashboard-main"
            }
          >
            <div className="navbar-header">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-4">
                    <button
                      type="button"
                      className="sidebar-toggle"
                      onClick={sidebarControl}
                    >
                      {sidebarActive ? (
                        <Icon
                          icon="iconoir:arrow-right"
                          className="icon text-2xl non-active"
                        />
                      ) : (
                        <Icon
                          icon="heroicons:bars-3-solid"
                          className="icon text-2xl non-active "
                        />
                      )}
                    </button>
                    <button
                      onClick={mobileMenuControl}
                      type="button"
                      className="sidebar-mobile-toggle"
                    >
                      <Icon icon="heroicons:bars-3-solid" className="icon" />
                    </button>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-3">
                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative">
                      <div className="d-flex align-items-center gap-3 justify-content-between">
                        <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                          Apply Maintenance
                        </span>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="maintenance"
                          name="maintenance"
                          checked={maintenance}
                          onChange={(e) => {
                            if (
                              window.confirm(
                                "Are you sure want to change the status?"
                              )
                            ) {
                              handleMaintenance(e);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="dropdown">
                      <button
                        className="d-flex justify-content-center align-items-center rounded-circle"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <img
                          src="https://wow-dash.com/demo/assets/images/user.png"
                          alt="image_user"
                          className="w-40-px h-40-px object-fit-cover rounded-circle"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-sm">
                        <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                          <div>
                            <h6 className="text-lg text-primary-light fw-semibold mb-2">
                              {profile.name}
                            </h6>
                          </div>
                          <button type="button" className="hover-text-danger">
                            <Icon
                              icon="radix-icons:cross-1"
                              className="icon text-xl"
                            />
                          </button>
                        </div>
                        <ul className="to-top-list">
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              to="/view-admin-profile"
                            >
                              <Icon
                                icon="solar:user-linear"
                                className="icon text-xl"
                              />{" "}
                              My Profile
                            </Link>
                          </li>
                          <li>
                            <button
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                              onClick={logout}
                            >
                              <Icon
                                icon="lucide:power"
                                className="icon text-xl"
                              />{" "}
                              Log Out
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* dashboard-main-body */}
            <div className="dashboard-main-body">{children}</div>

            {/* Footer section */}
            <footer className="d-footer">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <p className="mb-0">
                    © {new Date().getFullYear()} Flynomic. All Rights Reserved.
                  </p>
                </div>
                <div className="col-auto">
                  <p className="mb-0">
                    Made by{" "}
                    <span className="text-primary-600">dev-technosys</span>
                  </p>
                </div>
              </div>
            </footer>
          </main>
        </section>
      )}
    </>
  );
};

export default MasterLayout;
